import './api/initial';
import './api/chats';
import './api/messages';
import './api/symbols';
import './api/globalSearch';
import './api/middleSearch';
import './api/management';
import './api/sync';
import './api/accounts';
import './api/ai';
import './api/users';
import './api/topPeers';
import './api/bots';
import './api/settings';
import './api/twoFaSettings';
import './api/payments';
import './api/stars';
import './api/reactions';
import './api/statistics';
import './api/stories';
import './ui/initial';
import './ui/chats';
import './ui/bots';
import './ui/messages';
import './ui/globalSearch';
import './ui/middleSearch';
import './ui/stickerSearch';
import './ui/account';
import './ui/aiMessageEditor';
import './ui/users';
import './ui/settings';
import './ui/misc';
import './ui/payments';
import './ui/calls';
import './ui/mediaViewer';
import './ui/passcode';
import './ui/stars';
import './ui/reactions';
import './ui/stories';
import './ui/statistics';
import './apiUpdaters/initial';
import './apiUpdaters/chats';
import './apiUpdaters/messages';
import './apiUpdaters/users';
import './apiUpdaters/symbols';
import './apiUpdaters/misc';
import './apiUpdaters/settings';
import './apiUpdaters/twoFaSettings';
import './apiUpdaters/calls';
import './apiUpdaters/payments';
